// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row_sio86 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.search_xHFvZ {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.header_kmyKZ {
  display: flex;
}
.flexRight_bIEXa {
  margin-left: auto;
}
.perPageDropdown_u0M0R{
  min-width: 75px;
}
.left_Lkjl2 {
  height: 100%;
}
.pagination_rVbUP { 
  border-top : 1px solid var( --lighter-grey );
  background: white;
  position:absolute;
  bottom : 0;
  margin : 0;
  height : 40px;
  width : 100%;
  display: flex;
  justify-content:center;
  align-items:center;

  .innerPagination_Ngq3H {
    margin : 0
  }
}
.header_kmyKZ {
  padding : 10px 26px 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom:5px solid var( --background );/*var( --border-color );*/
}

.list_Xfpay {
  height: 100%;
  width: 100%;
  border:1px solid var( --lighter-grey );
}

.content_STG9P {
  height: 100%;
  padding: 10px 26px 10px 20px
}

.left_Lkjl2 {
  margin-right: auto;
}

.right_KWOdp {
  margin-left: auto;
}

.icon_JaM9c {
  background-color: var( --purple );
  color: white;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 5px;
  margin-left: 0;
  .textTop_oHO2n {
    vertical-align: text-top;
  }
}

.splitRight_RRSbK {
  width: 450px;
  height: 100%;
  background : var( --background );
}
.stopTimer_OB8Y5 i {
  color: var( --red );
}
.deleteTimer_jzfOf i {
  color: var( --grey )
}
.editor_T0iFo {
  height: 100%;
}

.filter_ZFeOf {
  display : flex;
  flex-direction: row;
  width: 100%;
}

.center_N8l20 {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  .loadMore_wh8CW {
    color: var( --purple );
    margin-right: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/script/style.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;EAElB;IACE;EACF;AACF;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C,CAAC,yBAAyB;AACvE;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":["@import \"../../style/theme.css\";\n\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.search {\n  width: 80%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.header {\n  display: flex;\n}\n.flexRight {\n  margin-left: auto;\n}\n.perPageDropdown{\n  min-width: 75px;\n}\n.left {\n  height: 100%;\n}\n.pagination { \n  border-top : 1px solid var( --lighter-grey );\n  background: white;\n  position:absolute;\n  bottom : 0;\n  margin : 0;\n  height : 40px;\n  width : 100%;\n  display: flex;\n  justify-content:center;\n  align-items:center;\n\n  .innerPagination {\n    margin : 0\n  }\n}\n.header {\n  padding : 10px 26px 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom:5px solid var( --background );/*var( --border-color );*/\n}\n\n.list {\n  height: 100%;\n  width: 100%;\n  border:1px solid var( --lighter-grey );\n}\n\n.content {\n  height: 100%;\n  padding: 10px 26px 10px 20px\n}\n\n.left {\n  margin-right: auto;\n}\n\n.right {\n  margin-left: auto;\n}\n\n.icon {\n  background-color: var( --purple );\n  color: white;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 5px;\n  margin-left: 0;\n  .textTop {\n    vertical-align: text-top;\n  }\n}\n\n.splitRight {\n  width: 450px;\n  height: 100%;\n  background : var( --background );\n}\n.stopTimer i {\n  color: var( --red );\n}\n.deleteTimer i {\n  color: var( --grey )\n}\n.editor {\n  height: 100%;\n}\n\n.filter {\n  display : flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  .loadMore {\n    color: var( --purple );\n    margin-right: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `row_sio86`,
	"search": `search_xHFvZ`,
	"header": `header_kmyKZ`,
	"flexRight": `flexRight_bIEXa`,
	"perPageDropdown": `perPageDropdown_u0M0R`,
	"left": `left_Lkjl2`,
	"pagination": `pagination_rVbUP`,
	"innerPagination": `innerPagination_Ngq3H`,
	"list": `list_Xfpay`,
	"content": `content_STG9P`,
	"right": `right_KWOdp`,
	"icon": `icon_JaM9c`,
	"textTop": `textTop_oHO2n`,
	"splitRight": `splitRight_RRSbK`,
	"stopTimer": `stopTimer_OB8Y5`,
	"deleteTimer": `deleteTimer_jzfOf`,
	"editor": `editor_T0iFo`,
	"filter": `filter_ZFeOf`,
	"center": `center_N8l20`,
	"loadMore": `loadMore_wh8CW`
};
export default ___CSS_LOADER_EXPORT___;
